import { mapState, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('controlManagementStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('controlManagementStore', Object.keys(actions)),
	...mapMutations('controlManagementStore', Object.keys(mutations))
};
